import { Card, Row, Col, Rate, Typography } from "antd";
import styles from "./FeedbackCard.module.scss";
import i18n from "../../i18n";
const { Title } = Typography;

interface FeedbackCardProps {
  data: Feedback;
}

export function FeedbackCard(props: FeedbackCardProps) {
  return (
    <Card>
      <Row>
        <Col>
          <span className={styles.rateNumber}>{props.data.score}</span>
        </Col>
        <Col>
          <Rate
            style={{ color: "#000" }}
            allowHalf
            disabled
            value={props.data.score}
          />
        </Col>
      </Row>
      <Title level={5}>{props.data.comment[i18n.language]}</Title>
    </Card>
  );
}
